export default __webpack_public_path__ + "static/media/youtube.f4bd027d.svg";